import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CorrespondenceCompanyDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-correspondencecompany',
  templateUrl: './correspondencecompany.component.html',
  styleUrls: ['./correspondencecompany.component.scss']
})
export class CorrespondencecompanyComponent implements OnChanges {

  correspondenceCompanyForm: FormGroup;
  correspondenceCompanyFormArray: FormGroup;
  control = new FormControl();
  @Input() correspondenceCompanys: CorrespondenceCompanyDto[];
  @Input() routeAnimationsElements: any;
  @Output() correspondenceCompany = new EventEmitter<CorrespondenceCompanyDto[]>()
  @Output() deleteCorrespondenceCompanyEvent = new EventEmitter<any>()

    selectedCorrespondenceCompany: any;
    filteredDelete: Array<any> = [];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createCorrespondenceCompanyForm();
    }

    createCorrespondenceCompanyForm() {
      this.correspondenceCompanyForm = this.fb.group({
        CorrespondenceCompanyName: ['', Validators.required],
        id: null
        });
        this.correspondenceCompanyFormArray = this.fb.group({ CorrespondenceCompanys: this.fb.array([])
          });
        this.setCorrespondenceCompany();
    }

  // method to display correspondenceCompanyS
  setCorrespondenceCompany() {
    const control  = this.correspondenceCompanyFormArray.controls.CorrespondenceCompanys as FormArray;
    console.log("Array", control);
    
    this.correspondenceCompanys.forEach( e => {
      control.push(
        this.fb.group({
          CorrespondenceCompanyName: e.CorrespondenceCompanyName,
          id: e.id
        })
      );
    });
  }


  // method to add CorrespondenceCompany
  addCorrespondenceCompany(value: CorrespondenceCompanyDto) {
    const control  = this.correspondenceCompanyFormArray.controls.CorrespondenceCompanys as FormArray;
    control.insert(0,
          this.fb.group({
            CorrespondenceCompanyName: value.CorrespondenceCompanyName,
            id: null
          })
       );
  }

  selectCorrespondenceCompany(value) {}

  // method to delete CorrespondenceCompany from arrary list
  deleteCorrespondenceCompany(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.correspondenceCompanyFormArray.controls.CorrespondenceCompanys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.correspondenceCompanys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.correspondenceCompanys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: CorrespondenceCompanyDto) {
    if(this.correspondenceCompanyForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.correspondenceCompanyFormArray.get('CorrespondenceCompanys')['controls'][this.selectedIndex].patchValue({CorrespondenceCompanyName: formValue.CorrespondenceCompanyName});
    } else {
      this.addCorrespondenceCompany(formValue);
    }
    this.selectedIndex = null;
    this.correspondenceCompanyForm.reset()
  }

  onEdit(index, value: CorrespondenceCompanyDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.correspondenceCompanyForm.patchValue({CorrespondenceCompanyName: value.CorrespondenceCompanyName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.correspondenceCompanyForm.reset();
  }

  onSubmit(formValue: CorrespondenceCompanyDto[]) {
  this.correspondenceCompany.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteCorrespondenceCompanyEvent.emit(this.filteredDelete);
  }
  }


}
